import { render, staticRenderFns } from "./CategoryPreview.vue?vue&type=template&id=10ef5bc3&scoped=true&"
import script from "./CategoryPreview.vue?vue&type=script&lang=js&"
export * from "./CategoryPreview.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPreview.vue?vue&type=style&index=0&id=10ef5bc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef5bc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardText,VCardTitle})
